import { get, post, put, _delete } from '@/services/http'
import { getUserIdentification, getUserToken } from '@/services/authService'
import { isEmpty } from '@/utils/StringUtil'

export function fetchActiveRepairs(keyword, size, page, sort) {
  return get(`/api/v1/repairing/fetch-by-criteria/active?size=${size}&page=${page}&sort=${sort}${!isEmpty(keyword) ? `&keyword=${keyword}` : ''}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchActionRequiredRequest(keyword, size, page, sort) {
  return get(`/api/v1/repairing/fetch-by-criteria/action-required?size=${size}&page=${page}&sort=${sort}${!isEmpty(keyword) ? `&keyword=${keyword}` : ''}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchNumberOfActionRequiredRepair() {
  return get(`/api/v1/repairing/fetch-number/action-required`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchClosedRepair(keyword, size, page, sort) {
  return get(`/api/v1/repairing/fetch-by-criteria/closed?&size=${size}&page=${page}&sort=${sort}${!isEmpty(keyword) ? `&keyword=${keyword}` : ''}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function fetchRepairsByFilter(data, size, page, sort) {
  return post(`/api/v1/repairing/fetch-by-criteria/report?size=${size}&page=${page}&sort=${sort}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function fetchHistoryByCriteria(id, size, page) {
  return get(`/api/v1/repairing/fetch-history-by-criteria?repairId=${id}&size=${size}&page=${page}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function createRepair(data) {
  return put(`/api/v1/repairing/create/repair`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function fetchRepair(id) {
  return get(`/api/v1/repairing/fetch/repair?repairId=${id}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function changePartInitialStatus(id, data) {
  return post(`/api/v1/repairing/change/initial/status/all?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function changePartMainStatus(id, data) {
  return post(`/api/v1/repairing/change/main/status/all?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateRepairStatus(id, status) {
  return post(`/api/v1/repairing/change/repair/status?username=${getUserIdentification()}&repairId=${id}${status ? `&status=${status}` : ''}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateShippingData(id, data) {
  return post(`/api/v1/repairing/save/shipping/data?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateTransitInfoData(id, data) {
  return post(`/api/v1/repairing/save/transit-info/data?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updatePickUpShippingData(id, data) {
  return post(`/api/v1/repairing/save/pick-up-shipping/data?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateTransitBackShippingData(id, data) {
  return post(`/api/v1/repairing/save/transit-back-shipping/data?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateDiagnosticStartDate(id, date) {
  return post(`/api/v1/repairing/save/diagnostic-start-date?username=${getUserIdentification()}&repairId=${id}&startDate=${date}`, {}, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function updateDiagnosticData(id, data) {
  return post(`/api/v1/repairing/save/part-in-diagnostic?repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function updateAllPartsServiceData(id, data) {
  return post(`/api/v1/repairing/update/parts/repair/data/all?username=${getUserIdentification()}&repairId=${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getUserToken()
    }
  })
}
export function deleteRepairInShippingDetailTab(id) {
  return _delete(`/api/v1/repairing/delete/shipping-details?id=${id}`, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function saveRequestApprovalComment(body) {
  return put(`/api/v1/repairing/save/request/approval/comment`, body, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function savePartApprovalComment(body) {
  return put(`/api/v1/repairing/save/part/approval/comment`, body, {
    headers: {
      'Authorization': getUserToken()
    }
  })
}
export function addRepairPart(repairId, data) {
  return post(`/api/v1/repairing/add/repair-part?repairId=${repairId}`, data, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": getUserToken()
    }
  })
}